import { grommet } from 'grommet/themes';
import { deepMerge } from 'grommet/utils';

const customTheme = deepMerge(grommet, {
  global: {
    colors: {
      brand: '#DD1B16',
      focus: '#b42b3f',
    },
    font: {
      family: 'Quicksand',
      size: '18px',
      height: '20px',
    },
    breakpoints: {
      xsmall: {
        value: 400,
      },
    },
  },
  heading: {
    extend: () => `margin-top: 12px; margin-bottom: 12px;`,
  },
  paragraph: {
    extend: () => `font-weight: 300; margin-top: 0;`,
    xxlarge: {
      size: '28px',
    },
  },
  textInput: {
    placeholder: {
      extend: () => `color: #44444`,
    },
  },
});

export default customTheme;
